<!-- @format -->

<template>
	<div class="content-box">
		<pc-config-provider>
			<el-table ref="tableRef" :key="tableStore.checkColumnList.length" v-loading="loading" v-bind="$attrs">
				<slot></slot>
				<el-table-column
					v-for="item in tableStore.checkColumnList"
					:key="item.code"
					:prop="item.code"
					:label="item.label"
					min-width="200"
				>
					<template #header="scope">
						<slot name="column-header" v-bind="scope">
							{{ scope.column.label }}
						</slot>
					</template>

					<template #default="scope">
						<slot name="column" v-bind="scope">
							{{ scope.row.fieldMap[scope.column.property] }}
						</slot>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				v-if="showTotal"
				v-model:currentPage="page.pageNum"
				v-model:page-size="page.pageSize"
				:total="total"
				:page-sizes="[10, 20, 50]"
				:default-page-size="1"
				background
				class="pagination"
				layout="total, sizes, prev, pager, next"
			/>
		</pc-config-provider>
	</div>
</template>

<script setup lang="ts">
	import { useTableStoreWithOut } from './store/index';
	import { PcConfigProvider } from '@/components';

	interface Props {
		loading?: boolean; // 是否加载
		total?: number; // 总数
		name: string; // 组件全局唯一参数
		showTotal?: boolean;
	}
	const props = withDefaults(defineProps<Props>(), {
		loading: false,
		total: 0,
		showTotal: true,
	});

	const emits = defineEmits(['pageChange']);

	const tableStore = useTableStoreWithOut(props.name);

	const tableRef = ref<InstanceType<typeof ElTable> | null>(null);

	const page = ref({ pageNum: 1, pageSize: 10 }); // 请求列表参数

	watch(page.value, (newVal) => {
		emits('pageChange', newVal);
	});

	defineExpose({ ref: tableRef });
</script>

<style scoped>
	.content-box {
		width: 100%;
		height: calc(100% - 20%);
		overflow: auto;

		.pagination {
			justify-content: flex-end;
		}
	}
</style>
